<template>
  <div class="wrapper wrapper_wide section_header">
    <div class="frame wrap_youtube">
      <!-- <PictureFrame v-if="!isMobile" :thumbnail="false" :path="'main/pc_top_main_a0'" :repeat="4"/>
      <PictureFrame v-if="!isMobile" :thumbnail="false" :path="'main/pc_top_main_b0'" :repeat="4"/>
      <PictureFrame v-if="isMobile && !isbrowserTabWidth" :thumbnail="false" :path="'main/sp_top_main_0'" :repeat="4"/>
      <PictureFrame v-if="isMobile && isbrowserTabWidth" :thumbnail="false" :path="'main/pc_top_main_a0'" :repeat="4"/>
      <PictureFrame v-if="isMobile && isbrowserTabWidth" :thumbnail="false" :path="'main/pc_top_main_b0'" :repeat="4"/> -->
      <!-- <Marquee/> -->
      <YoutubeMedia v-if="isMobile && isOnLine"></YoutubeMedia>
      <img class="pc_main" v-if="!isMobile && isOnLine" src="/assets/img/main/ksmedical_pc.gif" alt="">
      <img class="pc_main" v-if="!isMobile && !isOnLine" src="/assets/img/main/pc_top_main_a01.png" alt="">
      <img class="pc_side" v-if="!isMobile" src="/assets/img/main/pc_top_main_b01.png" alt="">
      <img v-if="isMobile && !isbrowserTabWidth && !isOnLine" src="/assets/img/main/sp_top_main_01.png" alt="">
      <img class="pc_main" v-if="isMobile && isbrowserTabWidth && !isOnLine" src="/assets/img/main/pc_top_main_a01.png" alt="">
      <img class="pc_side" v-if="isMobile && isbrowserTabWidth && !isOnLine" src="/assets/img/main/pc_top_main_b01.png" alt="">

      <!-- <p class="clinic_concept" v-html="copyTxt"></p> -->
      <p class="scroll_induction" @click="translate">Scroll</p>
    </div>
  </div>
</template>

<script>
// molcules
import Marquee from '../molcules/marquee.vue'
import PictureFrame from '../molcules/pictureFrame.vue'
import YoutubeMedia from '../molcules/youtube.vue'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'SectionHeader',
  components: {
    Marquee,
    PictureFrame,
    YoutubeMedia
  },
  props: {
    msg: String
  },
  computed: {
    ...mapState([
      'siteData',
      'isMobile'
    ]),
    copyTxt () {
      return this.siteData.home.header.copy
    },
    isbrowserTabWidth () {
      return window.innerWidth > 415
    },
    isOnLine () {
      return navigator.onLine
    }
  },
  methods: {
    ...mapActions([
      'smoothScroll'
    ]),
    translate () {
      const scrollPos = document.querySelector('.section_header + div').offsetTop - (this.isMobile ? document.querySelector('.header').clientHeight : 0)
      this.smoothScroll({
        duration: 100,
        scrollPos: scrollPos
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.wrap_youtube {
  overflow: hidden;
}
</style>
